module.exports = __webpack_public_path__ + "img/logo2.f62f80a9.png";